<div class="notifications-list">
  <div *ngIf="notificationsList.length > 0;else:emptyTpl ">
    <ul class="unlist-group custom-scrollbar">
      <li *ngFor="let notif of notificationsList">
        <div class="d-flex align-items-center transition item" [class.not-hover]="location != 'header-notification'">
          <i [ngClass]="notif.icon" class="i-maps-warning-e1 icon mr-3"></i>
          <div>
            <h4 class="title" [innerText]="notif.title"></h4>
            <span class="d-block time mt-1" [innerText]="notif.time">46 Gün Önce</span>
          </div>
        </div>
      </li>
    </ul>
    <a *ngIf="location === 'header-notification'" routerLink="/notifications" class="show-all d-flex  justify-content-between">
      <span>Tümünü Görüntüle</span> <span class="icon i-right-arrow"></span>
    </a>
  </div>
  <ng-template #emptyTpl>
    <nz-empty class="p-3"></nz-empty>
  </ng-template>
</div>
